"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutObjectTaggingOutput = {
    type: "structure",
    required: [],
    members: {
        VersionId: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-version-id"
        }
    }
};
//# sourceMappingURL=PutObjectTaggingOutput.js.map